module.exports = __webpack_public_path__ + "static/media/logo.eae52b80.svg";